import React from "react";
import { useGetHtmlApiQuery } from "../redux/services/apiHome";
import { Link } from "react-router-dom";
import Loader from "./Loader";
import DirectorSection from "./DirectorSection";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../hooks/useLanguageTranslation";

const AboutNeepco = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();

  const { data: aboutUsHtml = {}, isLoading: aboutUsHtmlIsLoading } =
    useGetHtmlApiQuery({ url: 136, lang: languageType });

  if (aboutUsHtmlIsLoading) {
    return <Loader />;
  }

  const htmlBody = aboutUsHtml?.body?.[0]?.value.slice(0, 800).concat("  ...");

  return (
    <>
      <div className="about-area">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-8 col-lg-8 space-l">
              <div className="about-sec about-home">
                <div className="title-sec">
                  <a
                    className="cursor-none"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      // आपकी क्लिक पर जो काम करना है वो यहाँ लिखें
                    }}
                    id="neepco-main"
                  >
                    <h1>
                      {getText("Welcome to NEEPCO", "नीपको में आपका स्वागत है")}
                    </h1>
                  </a>
                </div>
                <p
                  dangerouslySetInnerHTML={{
                    __html: htmlBody?.replace(
                      /About NEEPCO/g,
                      "Welcome to NEEPCO"
                    ),
                  }}
                ></p>

                <Link
                  to="/about-us/about-neepco"
                  className="quick-btn"
                  title={getText("Read More", "और पढ़ें")}
                  aria-label={"Read more about NEEPCO"}
                >
                  {getText("Read More", "और पढ़ें")}
                </Link>
              </div>
            </div>
            <DirectorSection data={aboutUsHtml} />
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutNeepco;
